<template>
  <div class="announcement">
    <div style="height: 40px"></div>
    <el-card class="card">
      <div class="title">公告</div>
      <p>
        按照市委统一部署，市委第一巡察组于2023年3月21日起对德阳发展集团党委开展
      </p>
      <p>
        常规巡察。巡察组坚持以习近平新时代中国特色社会主义思想为指导，全面落实党
      </p>
      <p>
        的二十大精神，把“两个维护”作为根本任务，贯彻“发现问题、形成震慑，推动
      </p>
      <p>
        改革、促进发展”的巡视工作方针，紧扣“三个聚焦”（聚焦党中央各项决策部署
      </p>
      <p>
        在基层的落实情况，聚焦群众身边腐败问题和不正之风以及群众反映强烈的问题，
      </p>
      <p>聚焦基层党组织建设）开展巡察监督。</p>
      <div style="height: 10px"></div>
      <p>
        根据《中国共产党巡视工作条例》和《四川省市（州）、县（市、区）党委巡察工
      </p>
      <p>
        作办法》规定，巡察组主要受理反映德阳发展集团党委领导班子及其成员、其他市
      </p>
      <p>
        管干部及下一级主要负责人问题的来信来电来访，重点是违反“六项纪律”（政治
      </p>
      <p>
        纪律、组织纪律、廉洁纪律、群众纪律、工作纪律、生活纪律）等方面的举报和反
      </p>
      <p>
        映。对其他不属于巡察受理范围的问题，将按规定转交被巡察单位和有关部门处理。
      </p>
      <div style="height: 10px"></div>
      <p>欢迎广大干部群众向巡察组反映情况。巡察组联系渠道如下。</p>
      <div style="height: 10px"></div>
      <p>一、联系电话：0838-2207886（受理时间8:00时至20:00时）。</p>
      <div style="height: 10px"></div>
      <p>二、联系信箱悬挂地址：</p>
      <p>1.德阳市太湖路9号德阳发展集团办公楼一楼大厅右侧；</p>
      <p>2.德阳市庐山南路三段12号德阳产投集团办公楼南侧；</p>
      <p>3.德阳市凯江路218号德阳建工集团办公楼一楼大厅左侧；</p>
      <p>4.德阳市泰山南路二段733号五洲广场第38层德阳城发集团1号消防电梯口；</p>
      <p>5.德阳市泰山南路二段586号德阳交通集团办公园区大门门岗外侧；</p>
      <p>6.德阳市天山南路三段99号德阳文旅集团办公楼一楼门厅出入口外侧；</p>
      <p>7.德阳市兰花巷24号德阳能源集团办公园区大门门岗外侧；</p>
      <p>
        8.德阳市泰山南路二段366号旌南大厦东侧德阳新媒体产业园（德阳商投集团、德
      </p>
      <p>阳会展集团）出入口外侧；</p>
      <p>
        9.德阳市泰山南路三段379号交通集团一运司汽车客运南站售票大厅北侧驾驶员之
      </p>
      <p>家出入口右侧；</p>
      <p>10.德阳市黄山路三段交通集团一运司汽车客运北站售票大厅出入口外侧；</p>
      <p>11.德阳市沱江东路52号建工集团德阳杰阳项管公司办公园区大门门岗内侧；</p>
      <p>
        12.德阳市柳江街9号附11号城发集团德阳杰阳排水公司办公园区大门门岗外侧。
      </p>
      <div style="height: 10px"></div>
      <p>三、电子邮箱：dyswxc1@163.com</p>
      <div style="height: 10px"></div>
      <p>四、来访接待点：德阳市庐山南路三段12号德阳产投集团一楼大厅右侧。</p>
      <div style="height: 10px"></div>
      <p>五、巡察组信访举报二维码：</p>
      <div style="height: 10px"></div>
      <div class="code">
        <img src="../assets/code.png" alt="" />
      </div>
      <div style="height: 10px"></div>
      <div class="footer">
        <p>中共德阳市委第一巡察组</p>
        <p>2023年3月21日</p>
      </div>
      <div class="ok">
        <el-button type="primary" @click="handleOk">确定</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  methods: {
    handleOk() {
      this.$router.push("/questionnaire");
    },
  },
};
</script>

<style lang="scss">
.announcement {
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1000px;
    height: 100%;
    margin: 0 auto 10px;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      font-size: 26px;
      color: #666;
      font-weight: bold;
    }
    .code {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        height: 150px;
      }
    }
    .footer {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .ok {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 40px;
    }
  }
}
</style>